// Cross-sell "Vous pourriez aussi aimer" dans le tiroir panier
// + ajout au panier en AJAX (sans recharger la page), pour le cross-sell et pour l'offre pack.
(function () {
  function formatMoney(cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 2
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' €';
    }
  }

  function escapeHtml(str) {
    return String(str || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // Ajoute un ou plusieurs articles au panier et met a jour le tiroir sur place,
  // sans rechargement de page. Reutilisable depuis n'importe quel bouton "ajouter" du site.
  window.hcAddToCartAjax = async function (items) {
    var addRes = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: items,
        sections: 'cart-drawer',
        sections_url: window.location.pathname
      })
    });

    if (!addRes.ok) {
      var errData = {};
      try { errData = await addRes.json(); } catch (e) {}
      throw new Error(errData.description || errData.message || 'add failed');
    }

    var addData = await addRes.json();

    if (addData.sections && addData.sections['cart-drawer']) {
      var doc = new DOMParser().parseFromString(addData.sections['cart-drawer'], 'text/html');
      var newInner = doc.querySelector('.drawer__inner');
      var currentDrawer = document.querySelector('cart-drawer');
      var currentInner = currentDrawer ? currentDrawer.querySelector('.drawer__inner') : null;
      if (newInner && currentInner) {
        currentInner.innerHTML = newInner.innerHTML;
        currentDrawer.classList.remove('is-empty');
      }
    }

    // Met a jour le compteur du panier dans l'en-tete (ne depend pas du rendu de section).
    try {
      var cartRes = await fetch('/cart.js');
      var cart = await cartRes.json();
      var bubbleWrap = document.getElementById('cart-icon-bubble');
      if (bubbleWrap) {
        var bubble = bubbleWrap.querySelector('.cart-count-bubble span[aria-hidden]');
        if (bubble) {
          bubble.textContent = cart.item_count;
        } else if (cart.item_count > 0) {
          var span = document.createElement('div');
          span.className = 'cart-count-bubble';
          span.innerHTML = '<span aria-hidden="true">' + cart.item_count + '</span>';
          bubbleWrap.appendChild(span);
        }
      }
    } catch (e) {}

    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
    }

    return addData;
  };

  class CartCrossSell extends HTMLElement {
    connectedCallback() {
      this.load();
    }

    async load() {
      var seedId = this.dataset.seedId;
      if (!seedId || seedId === '') {
        this.remove();
        return;
      }
      var excludeIds = (this.dataset.excludeIds || '')
        .split(',')
        .filter(Boolean)
        .map(function (v) { return parseInt(v, 10); });

      var products = [];
      try {
        var res = await fetch('/recommendations/products.json?product_id=' + encodeURIComponent(seedId) + '&limit=8&intent=related');
        if (!res.ok) throw new Error('bad response');
        var data = await res.json();
        products = (data.products || []).filter(function (p) {
          return excludeIds.indexOf(p.id) === -1 && p.available;
        }).slice(0, 3);
      } catch (e) {
        this.remove();
        return;
      }

      if (!products.length) {
        this.remove();
        return;
      }

      var heading = this.dataset.heading || 'Vous pourriez aussi aimer';
      var itemsHtml = products.map(function (p) {
        var variant = (p.variants && p.variants[0]) || {};
        var variantId = variant.id || p.id;
        var img = p.featured_image || (p.images && p.images[0]) || '';
        var compareAt = variant.compare_at_price;
        var priceHtml = '<span class="now">' + formatMoney(p.price) + '</span>';
        if (compareAt && compareAt > p.price) {
          priceHtml += '<span class="was">' + formatMoney(compareAt) + '</span>';
        }
        return (
          '<div class="cart-cross-sell__item">' +
            '<a href="' + p.url + '" class="cart-cross-sell__img">' +
              '<img src="' + img + '" alt="' + escapeHtml(p.title) + '" loading="lazy" width="56" height="56">' +
            '</a>' +
            '<div class="cart-cross-sell__info">' +
              '<a href="' + p.url + '" class="cart-cross-sell__title">' + escapeHtml(p.title) + '</a>' +
              '<div class="cart-cross-sell__price">' + priceHtml + '</div>' +
            '</div>' +
            '<button type="button" class="cart-cross-sell__add" data-variant-id="' + variantId + '" aria-label="Ajouter ' + escapeHtml(p.title) + ' au panier">+</button>' +
          '</div>'
        );
      }).join('');

      this.innerHTML =
        '<div class="cart-cross-sell__heading">' + escapeHtml(heading) + '</div>' +
        '<div class="cart-cross-sell__list">' + itemsHtml + '</div>';

      var self = this;
      this.querySelectorAll('.cart-cross-sell__add').forEach(function (btn) {
        btn.addEventListener('click', function () { self.addItem(btn); });
      });
    }

    async addItem(btn) {
      if (btn.disabled) return;
      btn.disabled = true;
      btn.textContent = '…';
      var variantId = parseInt(btn.dataset.variantId, 10);
      try {
        await window.hcAddToCartAjax([{ id: variantId, quantity: 1 }]);
      } catch (e) {
        btn.disabled = false;
        btn.textContent = '+';
      }
    }
  }

  if (!customElements.get('cart-cross-sell')) {
    customElements.define('cart-cross-sell', CartCrossSell);
  }
})();
